export default [
    "24 24",
    '<path d="M14.3994 19.8C14.3994 17.5909 11.7131 15.8 8.39941 15.8C5.08571 15.8 2.39941 17.5909 2.39941 19.8M18.3994 16.8V13.8M18.3994 13.8V10.8M18.3994 13.8H15.3994M18.3994 13.8H21.3994M8.39941 12.8C6.19027 12.8 4.39941 11.0092 4.39941 8.80005C4.39941 6.59091 6.19027 4.80005 8.39941 4.80005C10.6086 4.80005 12.3994 6.59091 12.3994 8.80005C12.3994 11.0092 10.6086 12.8 8.39941 12.8Z" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

